import { useState, useCallback, useEffect } from 'react';
import { adminPaymentsService, isApiError } from '@dopomogai/api-client';
import type { InvoiceLog } from '@dopomogai/api-client';
import { AgentKitError } from '../../types';

export const useListInvoices = (autoFetch = true) => {
  const [invoices, setInvoices] = useState<InvoiceLog[]>([]);
  const [error, setError] = useState<AgentKitError | null>(null);
  const [isLoading, setIsLoading] = useState(autoFetch);

  const fetchInvoices = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    const res = await adminPaymentsService.listInvoices();

    if (isApiError(res)) {
      setError(new AgentKitError('Failed to fetch invoices', res));
      setInvoices([]);
    } else {
      setInvoices(res);
    }
    setIsLoading(false);
  }, []);

  // Fetch automatically on mount if requested
  useEffect(() => {
    if (autoFetch) {
      fetchInvoices();
    }
  }, [autoFetch, fetchInvoices]);

  return { invoices, isLoading, error, refetch: fetchInvoices };
};